import React from 'react';

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=".75rem"
      height=".875rem"
      viewBox="0 0 12 14"
      version="1.1">
      <title>noun-delete-4691165</title>
      <g
        id="Prompt-Cards"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="3.5.2---Prompt-Cards---view-all-prompt-options"
          transform="translate(-1243, -405)"
          fill="#53617A"
          fillRule="nonzero">
          <g id="Group-5" transform="translate(1232, 398)">
            <g id="noun-delete-4691165" transform="translate(11, 7)">
              <path
                d="M12.000149,3 C11.9992452,2.17194755 11.3282015,1.50090386 10.500149,1.5 L7.98824901,1.5 C7.98559147,0.673222012 7.31642415,0.00342955231 6.48964901,0 L5.50722901,0 C4.67917656,0.000903855827 4.00813286,0.671947554 4.00722901,1.5 L1.50014901,1.5 C0.765518358,1.49795384 0.138132787,2.02967028 0.0197029698,2.75469494 C-0.0987268477,3.4797196 0.326856115,4.18343415 1.02395401,4.415255 L1.50795401,12.588625 C1.55548663,13.3809294 2.21154533,13.9993309 3.00527401,14 L8.99502401,14 C9.78875075,13.9993282 10.4448065,13.3809275 10.492339,12.588625 L10.976339,4.415285 C11.5859925,4.21215164 11.9980026,3.64260094 12.000149,3 Z M5.50722901,1 L6.48964901,1 C6.76522382,1.00097646 6.98822426,1.22442379 6.98864901,1.5 L5.00722901,1.5 C5.0075871,1.22400609 5.2312351,1.00035809 5.50722901,1 L5.50722901,1 Z M9.49428901,12.52954 C9.47840637,12.7936864 9.25964744,12.9998241 8.99502401,13 L3.00527401,13 C2.74065058,12.9998241 2.52189165,12.7936864 2.50600901,12.52954 L2.03064901,4.5 L9.96964901,4.5 L9.49428901,12.52954 Z M10.500149,3.5 L1.50014901,3.5 C1.22400663,3.5 1.00014901,3.27614237 1.00014901,3 C1.00014901,2.72385763 1.22400663,2.5 1.50014901,2.5 L10.500149,2.5 C10.7762914,2.5 11.000149,2.72385763 11.000149,3 C11.000149,3.27614237 10.7762914,3.5 10.500149,3.5 Z M4.23232901,9.56079 L5.29311901,8.5 L4.23232901,7.43921 C4.10603025,7.31291126 4.05670497,7.12882682 4.10293352,6.95629952 C4.14916207,6.78377222 4.28392123,6.64901306 4.45644853,6.60278451 C4.62897583,6.55655597 4.81306026,6.60588125 4.93935901,6.73218 L6.00014901,7.79297 L7.06093901,6.73218 C7.25617995,6.53693906 7.57272806,6.53693906 7.767969,6.73218001 C7.96320994,6.92742095 7.96320995,7.24396906 7.76796901,7.43921 L6.70717901,8.5 L7.76796901,9.56079 C7.96320993,9.75603095 7.96320992,10.072579 7.76796899,10.26782 C7.57272805,10.4630609 7.25617995,10.4630609 7.06093901,10.26782 L6.00014901,9.20703 L4.93935901,10.26782 C4.81306026,10.3941188 4.62897583,10.443444 4.45644853,10.3972155 C4.28392123,10.3509869 4.14916207,10.2162278 4.10293352,10.0437005 C4.05670497,9.87117318 4.10603025,9.68708874 4.23232901,9.56079 L4.23232901,9.56079 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
